import React from 'react';
import PropTypes from 'prop-types';
import { StyledRow } from '../styled';

import { compose } from 'recompose';

import { journeyCardEnhancer } from 'modules/journey/card/hoc';

import StopStatusLog from 'modules/journey/stop-status-log';
import {
  getJourneyFields,
  getJourneyAdditionalDocumentsFields,
  getJourneyStopFields,
} from 'redux/modules/job-detail/selectors';

const selectors = {
  getJourneyFields,
  getJourneyAdditionalDocumentsFields,
  getJourneyStopFields,
};

const enhance = compose(journeyCardEnhancer(selectors));

const StatusRow = React.memo(({ stopId, item }) => {
  return (
    ((!!item.driver || item.stops[0].shipment_state_logs.length > 0) && (
      <StyledRow noPadding rowHeight={48}>
        <StopStatusLog
          variant="big"
          actionSource="DETAIL"
          stopId={stopId}
          journeyId={item.id}
          isHandleable
        />
      </StyledRow>
    )) || <StyledRow noPadding rowHeight={48} showBackground={false} />
  );
});

StatusRow.propTypes = {
  stop: PropTypes.object,
  stops: PropTypes.array,
  stopId: PropTypes.number,
  item: PropTypes.object,
};

StatusRow.defaultProps = {
  stop: {},
};

export default enhance(StatusRow);
